import React from "react"
import { Link } from "react-router-dom"
import { buildModuleVOOverviewUrl } from "../moduleVoNavigation"
import { useModuleVOConfigParams } from "../hooks/useModuleVOConfigParams"
import MarginValuation from "../components/MarginValuation"

export default function ConfigMarginValuation() {
    const { scope } = useModuleVOConfigParams()

    return (
        <div className="container-fluid mb-2">
            <div className="d-flex justify-content-between align-items-center mb-3">
                <h4>Nouvelle config — Marge de la cotation</h4>
                <Link to={buildModuleVOOverviewUrl('marginValuation')} className="btn btn-outline-secondary btn-sm">
                    <i className="fa fa-arrow-left tw-mr-2"></i>
                    Retour
                </Link>
            </div>

            <MarginValuation mode="config" scope={scope} />
        </div>
    )
}
